<script>
    import Banner from '@itslearning/prometheus/assets/feedback/Banner/v1/Banner.svelte'
    import Page from '../components/Page/Page.svelte';
    import PageResultSummary from './PageResultSummary/PageResultSummary.svelte';
    import Tabs from '@itslearning/prometheus/assets/Navigation/Tabs/v1/Tabs.svelte'
    import TabPanel from '@itslearning/prometheus/assets/Navigation/Tabs/v1/TabPanel.svelte';
    import QuestionList from './QuestionList/QuestionList.svelte';
    import Respondents from './Respondents/Respondents.svelte';
    import {navigation, permissions, surveyTitle} from '../stores';
    import {txt} from '../i18n/i18n';
    import {onMount} from 'svelte';
    import SurveyInformation from './SurveyInformation.svelte';
    import {isInIframe} from '../helpers';
    
    let tabs = [];
    let showErrorMessage = false;
    let message = { text: txt('Unknown_error'), type: 'warning' };
       
    $: selectedTabIndex = Math.max(tabs.findIndex(t => t.id === $navigation.viewTabId), 0); 
    $: canViewQuestionsTab = $permissions.canModify || $permissions.canModifyInstance;    

    onMount(() => {
        tabs.push({ id: 'tabSurvey', target: '#survey', title: txt('Survey') });
        if (canViewQuestionsTab) { // we want to let teachers who have imported survey from library to also see the list of questions (modifyInstance === true)
            tabs.push({ id: 'tabQuestions', target: '#questions', title: txt('Questions') });
        }
        if ($permissions.canEvaluate) {
            tabs.push({id: 'tabResults', target: '#results', title: txt('Responses')});
            tabs.push({id: 'tabResultSummary', target: '#summary', title: txt('Responses_summary')});
        }
        tabs = tabs;
    });

    function onTabChanged(e) {
        navigation.update((n) => {
            n.viewTabId = e.detail.selectedTabId;
            return n;
        });
    }
</script>

<Page title={isInIframe() ? txt('Survey_title') : surveyTitle} displayHeading={!isInIframe()} headingLevel={1}>
    <Banner visible={showErrorMessage} close={txt('Close')} type={message.type} text={message.text}></Banner>
    {#if $permissions.canModify || $permissions.canModifyInstance || $permissions.canEvaluate}
        <Tabs tabs={tabs} selectedIndex={selectedTabIndex} on:tabChanged={onTabChanged}>
            <TabPanel id="survey" labelledBy="tabSurvey" headingLevel="h2" title={txt('Survey')}>
                <SurveyInformation  bind:showErrorMessage={showErrorMessage}/>
            </TabPanel>

            {#if canViewQuestionsTab}
                <TabPanel id="questions" labelledBy="tabQuestions" headingLevel="h2" title={txt('Questions')}>
                    <QuestionList></QuestionList>
                </TabPanel>
            {/if}

            {#if $permissions.canEvaluate}
                <TabPanel id="results" labelledBy="tabResults" headingLevel="h2" title={txt('Responses')}>
                    <Respondents></Respondents>
                </TabPanel>
                <TabPanel id="resultSummary" labelledBy="tabResultSummary" headingLevel="h2" title={txt('Responses_summary')}>
                    <PageResultSummary></PageResultSummary>
                </TabPanel>
            {/if}
        </Tabs>
    {:else if $permissions.canRead}
        <SurveyInformation bind:showErrorMessage={showErrorMessage}/>
    {/if}
</Page>
